import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const DEFAULT_TITLE = 'RhyBus Customer Portal' // Define the default title if none is added eg: /generate
const usePageTitle = (title = DEFAULT_TITLE) => {
  const location = useLocation()

  useEffect(() => {
    document.title = title
  }, [location.pathname, title])
}

export default usePageTitle
